import React from "react";
import { useSolutionsSelect } from "@/states/solution.state";
import typesComponentForHomePage from "@/components/common/types";
import { QR_TYPES } from "@/constant/qr_type.enum";
const RenderTypes: React.FC = () => {
  const {
    solutionsSelectedTypes
  } = useSolutionsSelect();

  // Find the component based on the local type state
  const TypeComponent = typesComponentForHomePage.find(e => e.type.toLowerCase() === (solutionsSelectedTypes?.toLowerCase() || QR_TYPES.URL))?.components;

  // Directly return the component if it exists, or null if it doesn't
  return TypeComponent ? <TypeComponent data-sentry-element="TypeComponent" data-sentry-component="RenderTypes" data-sentry-source-file="RenderTypes.tsx" /> : null;
};
export default RenderTypes;